<template>
  <section>
    <ui-list
      :heading="heading"
      :headings="[$t('fields.name'), $tc('models.role', 1), '']"
      :items="users"
      :sort="[
        { prop: 'lastName', type: false },
        { prop: 'role', prop2: 'name', type: 'level2' }
      ]"
    >
      <template v-slot:default="props">
        <ui-list-data
          :text="
            `${
              props.item.firstName
                ? props.item.firstName
                : $t('misc.not-registered')
            } ${props.item.lastName ? props.item.lastName : ''}`
          "
          :info="props.item.email"
        >
        </ui-list-data>

        <ui-list-data
          type="tag"
          :text="`${$t('roles.' + props.item.role.name)}`"
        />

        <ui-list-data small>
          <!-- <ui-link type="danger" size="small" uppercase @click="removeUser(props.item.id)">{{ $t('actions.remove') }}</ui-link> -->
          <ui-link
            type="danger"
            size="small"
            uppercase
            @click="showDeleteModal(true, props.item)"
            >{{ $t('actions.remove') }}</ui-link
          >
        </ui-list-data>
      </template>
    </ui-list>

    <ui-modal
      :show="showDelete"
      :text="
        $t('actions.confirm_delete', {
          model: $tc('models.user').toLowerCase()
        })
      "
      :info="$t('info.delete_company_user')"
      :confirmText="$t('actions.delete')"
      @confirm="removeUser()"
      @cancel="showDeleteModal(false)"
    >
    </ui-modal>
  </section>
</template>

<script>
import UiLink from '@/components/ui/UiLink';
import UiList from '@/components/ui/UiList';
import UiListData from '@/components/ui/UiListData';
import UiModal from '@/components/ui/UiModal';

export default {
  props: {
    heading: {
      type: String
    },
    users: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      markedDelete: null,
      showDelete: false
    };
  },

  components: {
    UiLink,
    UiList,
    UiListData,
    UiModal
  },

  methods: {
    removeUser() {
      this.$emit('removeUser', this.markedDelete.id);
      this.showDeleteModal(false);
    },

    showDeleteModal(show, item) {
      this.showDelete = show;
      if (show) {
        this.markedDelete = item;
      } else {
        this.markedDelete = null;
      }
    }
  }
};
</script>
